import { section } from "@/neon";

import { animateCollectionBanner } from "@/lib/animation";

section("collection-banner", {
  videoHandler: null,

  onLoad() {
    this.animateCollectionBanner = animateCollectionBanner(this.container);
  },

  onUnload() {
    this.animateCollectionBanner?.destroy();
  },
});
